import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTORS]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_POPUP]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/:baseExecutorId/popup/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR_PREVIEW]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/:baseExecutorId/preview/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].GET_BUSINESS_PROCESS_BASE_EXECUTOR]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/:baseExecutorId/',
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].CREATE_BUSINESS_PROCESS_BASE_EXECUTOR]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/',
		requestOptions: { method: 'POST' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PATCH_BUSINESS_PROCESS_BASE_EXECUTOR]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/:baseExecutorId/',
		requestOptions: { method: 'PATCH' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].PUT_BUSINESS_PROCESS_BASE_EXECUTOR]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/:baseExecutorId/',
		requestOptions: { method: 'PUT' },
	},
	[ModulesConfigMap[ModulesMap.BUSINESS_PROCESS_BASE_EXECUTORS].DELETE_BUSINESS_PROCESS_BASE_EXECUTOR]: {
		url: '/company/:companyId/business_processes/:businessProcessId/base_executors/:baseExecutorId/',
		requestOptions: { method: 'DELETE' },
	},
}
